export default {
  name: 'BottomTabBar',
  props: {
    items: {
      type: Array,
      required: true
    },
    active: {
      type: String,
      default: null
    }
  }
};